import { ReactElement } from 'react';
import styles from '../../../../windows-updates/grid/cell-renderers/UpdateStatusCells.module.scss';
import { Typography } from '@getgo/chameleon-web-react-wrapper/register';
import { useTranslation } from 'react-i18next';

function InstalledByCellRenderer({ value }: { value: boolean | null }): ReactElement {
  const { t } = useTranslation();
  const getCellText = (): string => {
    switch (value) {
      case true:
        return t(`deviceDetails.grid.windows.installedByClientTypes.resolve`);
      case false:
        return t(`deviceDetails.grid.windows.installedByClientTypes.windowsUpdate`);
      default:
        return t(`deviceDetails.grid.windows.nullValue`);
    }
  };
  return (
    <div className={styles.cell}>
      <Typography variant="body-small">{getCellText()}</Typography>
    </div>
  );
}

export default InstalledByCellRenderer;
